import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// ScrollToTop Component
import ScrollToTop from './Components/PublicComponents/ScrollToTop'; 

// Public Components
import Navbar from './Components/PublicComponents/NavbarComponents/Navbar';
import HomePage from './Components/PublicComponents/HomeComponents/HomePage';
import AboutAssociation from './Components/PublicComponents/AboutUsComponents/AboutAssociation';
import MissionVision from './Components/PublicComponents/AboutUsComponents/MissionVision';
import Leadership from './Components/PublicComponents/AboutUsComponents/Leadership';
import ProjectsPage from './Components/PublicComponents/ProjectsComponents/ProjectsPage';
import EventsAndNewsPage from './Components/PublicComponents/Events&NewsComponents/EventsAndNewsPage';
import GalleryPage from './Components/PublicComponents/GalleryComponents/GalleryPage';
import BecomeMember from './Components/PublicComponents/MembershipComponents/BecomeMember';
import RegistrationFormPage from './Components/PublicComponents/MembershipComponents/RegistrationFormPage';
import SupportProjectPage from './Components/PublicComponents/ProjectsComponents/SupportProjectPage';
import JobsInternshipPage from './Components/PublicComponents/Jobs&MentorshipComponents/JobsInternshipPage';
import JobDetailsPage from './Components/PublicComponents/Jobs&MentorshipComponents/JobDetailsPage';
import MentorshipPage from './Components/PublicComponents/Jobs&MentorshipComponents/MentorshipPage';
import AlumniTalentPoolPage from './Components/PublicComponents/Jobs&MentorshipComponents/AlumniTalentPoolPage';
import ContactUsPage from './Components/PublicComponents/ContactUsComponents/ContactUsPage';
import FooterPage from './Components/PublicComponents/FooterComponents/FooterPage';
import TalentRegistrationPage from './Components/PublicComponents/Jobs&MentorshipComponents/TalentRegistrationPage';

function App() {
  return (
    <Router>
      <ScrollToTop /> 
      <div className="App">
        <Navbar />
        <Routes>
          {/* Public Website Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="about-association" element={<AboutAssociation />} />
          <Route path="mission-vision" element={<MissionVision />} />
          <Route path="leadership" element={<Leadership />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="news-events" element={<EventsAndNewsPage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="membership" element={<BecomeMember />} />
          <Route path="membership/register" element={<RegistrationFormPage />} />
          <Route path="support" element={<SupportProjectPage />} />
          <Route path="jobs&internship" element={<JobsInternshipPage />} />
          <Route path="jobs/:id" element={<JobDetailsPage />} />
          <Route path="mentorship" element={<MentorshipPage />} />
          <Route path="alumni-talent-pool" element={<AlumniTalentPoolPage />} />
          <Route path="alumni-talent-pool-registration" element={<TalentRegistrationPage/>} />
          <Route path="contact-us" element={<ContactUsPage />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />

          
        </Routes>
        <FooterPage />
      </div>
    </Router>
  );
}

export default App;